import * as React from "react";
import "./style.scss";
import { Choropleth } from "../../../../core/Chart";
import { processMapData } from "../../../../core/Chart/common/utils";

export class MapChoropleth extends React.Component<any, any> {
  render() {
    let { group_by, compare_by, metric, data, us_based } = this.props;
    let { val, max, min, zeroData, extraStates } = processMapData(
      data,
      metric,
      us_based
    );

    return (
      <div>
        {data && data.length > 0 ? (
          <Choropleth
            country={us_based ? "usa" : "canada"}
            metric={metric}
            metricData={data}
            extraStates={extraStates}
            max={max}
            min={min}
            data={val}
            zeroData={zeroData}
          />
        ) : (
          "Loading"
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/Visualizations/Choropleth/index.tsx